/** `Trust Reg No E/7038(P)` from `tenants.trustId`. */
export function formatTrustRegNo(trustId: string): string {
  const id = trustId.trim();
  return id ? `Trust Reg No ${id}` : "";
}

/** Trust name + registration lines for receipt headers (exact DB values). */
export function formatTenantTrustSubTitle(trustName: string, trustId: string): string {
  return [trustName.trim(), formatTrustRegNo(trustId)].filter(Boolean).join("\n");
}
